// Qurilmaning server bilan aloqasi (Q-021): brauzer restoran logini va paroli bilan
// restoran qurilmasiga aylanadi va o'z Supabase Auth hisobini oladi.
import { ApiError } from '@onepos/client';
import { deviceApi } from '../lib/api';

export { deviceApi };

export const APP_VERSION = '0.6.0';

/** Restoran logini bilan kirish: qurilma hisobi yaratiladi (tasdiqlanmagan) va eslab qolinadi */
export async function loginDevice(login: string, password: string): Promise<void> {
  // Eski (uzilgan) qurilma hisobi qolgan bo'lsa — tashlab yuboriladi
  if (deviceApi.session) await deviceApi.signOut().catch(() => undefined);
  const res = await deviceApi.invoke<{ ok: boolean; email: string; password: string }>('device-login', {
    login: login.trim().toLowerCase(),
    password,
    app_version: APP_VERSION,
  });
  if (!res?.email || !res.password) throw new ApiError('SERVER_ERROR', 500);
  await deviceApi.signIn(res.email, res.password);
}

/** Vaqt chegarasi bilan so'rov: javob kelmasa — tarmoq xatosi deb hisoblanadi */
export async function withTimeout<T>(p: Promise<T>, ms: number): Promise<T> {
  let timer: ReturnType<typeof setTimeout> | undefined;
  try {
    return await Promise.race([
      p,
      new Promise<never>((_, reject) => {
        timer = setTimeout(() => reject(new ApiError('NETWORK', 0, 'timeout')), ms);
      }),
    ]);
  } finally {
    if (timer) clearTimeout(timer);
  }
}

export function uuid(): string {
  return crypto.randomUUID();
}
